export enum HttpStatusCode {
  UNAUTHORIZED = 401,
}

export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://taxi.atix.biz";
